import i18next, { type i18n as I18n } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export interface I18nInitOptions {
  /** Base path where locale resources live, e.g. '/locales' (storefront public/) or '/i18n' (backoffice). */
  loadPath: string;
  /** Comma-separated list of namespaces to pre-load. Defaults: ['common', 'errors', 'status']. */
  ns?: readonly string[];
  /** Override fallback language. Default 'en-US'. */
  fallbackLng?: string;
}

export const initI18n = async (opts: I18nInitOptions): Promise<I18n> => {
  await i18next
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      backend: {
        loadPath: `${opts.loadPath}/{{lng}}/{{ns}}.json`,
      },
      fallbackLng: opts.fallbackLng ?? 'en-US',
      supportedLngs: ['ko-KR', 'en-US', 'ja-JP', 'zh-CN'],
      ns: [...(opts.ns ?? ['common', 'errors', 'status'])],
      defaultNS: 'common',
      detection: {
        order: ['cookie', 'localStorage', 'navigator'],
        caches: ['cookie'],
      },
      interpolation: {
        escapeValue: false, // react already escapes
      },
      returnEmptyString: false,
      returnNull: false,
    });

  return i18next;
};

export { useTranslation, Trans } from 'react-i18next';
export { i18next };
